export default __webpack_public_path__ + "static/carousel-1-b1224d502d1ffc9178a2ed1db94851eb.jpg";